import React, { Fragment, useState } from 'react'
import propTypes from "prop-types"
import { Menu, Transition } from '@headlessui/react'
import { Button } from '..'
import { SpinnerPrimary } from '../../../theme/icons'
import { useClickOutside } from '../../useOutsideClick'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const ButtonSelect = React.memo(({ btnTitle, options, loader, icon,...rest }) => {
    const [isShowing, setIsShowing] = useState(false);
    const [selectIndex, setselectIndex] = useState(-1);
    const ref = React.createRef();

    const handleClick = ({ option, i }) => {
        setselectIndex(i);
        option?.onClick();
        setIsShowing(false);
    }

    useClickOutside(ref, () => setIsShowing(false))

    const propertyIcon = icon ? { ...icon, props: { ...icon.props, className: isShowing ? ` stroke-white ${icon.props?.className}` : icon.props?.className } } : ""


    return (
        <div ref={ref} {...rest}>
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <Button className={`p-2 rounded-full flex items-center ${isShowing ? 'bg-primary-500  hover:bg-primary-300' : ' hover:bg-primary-50'}`} variant="secondary"
                        loaderClassName="!m-auto w-4 h-4 min-w-5" loaderVariant="secondary"
                        loader={loader} disabled={loader} loaderText={""} onClick={() => setIsShowing((isShowing) => !isShowing)} text={btnTitle} icon={
                            <>
                                {propertyIcon}
                                {/* {isShowing && <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>} */}
                            </>
                        }></Button>
                </div>
                <Transition
                    show={isShowing}
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95">
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="py-1">
                            {!!options?.length &&
                                options?.map((option, i) =>
                                    <Menu.Item key={option?.title}>
                                        {({ active }) => (
                                            <button onClick={() => handleClick({ option, i })} disabled={loader || option?.disabled}
                                                className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700 ', 'block px-4 py-2 text-sm w-full', option?.disabled ? 'cursor-not-allowed':'cursor-pointer')}>
                                                <div className='flex gap-2 items-center '>
                                                    <div >{loader && selectIndex === i ? <SpinnerPrimary /> : option?.icon}</div>
                                                    <div>{option?.title}</div>
                                                </div>
                                            </button>
                                        )}
                                    </Menu.Item>)}
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    )
})

ButtonSelect.propTypes = {
    btnTitle: propTypes.string,
    options: propTypes.array
}
ButtonSelect.defaultProps = {
    btnTitle: '',
    options: []
}